import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { Store } from '../../../../../services/store';
import { toVoid } from '../../../../../utils/void';
import { BomItemStagesProvider } from './bom-item-stages.provider';
import { BomItemStagesDto } from './bom-item-stages.dto';

export interface BomItemStagesState {
  loading: boolean;
  parts: BomItemStagesDto[] | undefined;
}

const INITIAL_STATE: BomItemStagesState = {
  loading: false,
  parts: undefined
};

@Injectable({ providedIn: 'root' })
export class BomItemStagesStore extends Store<BomItemStagesState> {
  constructor(private provider: BomItemStagesProvider) {
    super(INITIAL_STATE);
  }

  init(bomItemId: number | undefined): Observable<void> {
    if (bomItemId === undefined) {
      // item not saved in backend yet (/bom/new) — the floor has said nothing about it
      this.update(state => ({ ...state, loading: false, parts: [] }));
      return of(undefined);
    }

    this.update(state => ({ ...state, loading: true }));

    return this.provider.getStages(bomItemId)
      .pipe(
        tap(parts => {
          this.update(state => ({
            ...state,
            loading: false,
            parts
          }));
        }),
        toVoid()
      );
  }
}
